"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const list_1 = require("./list");
/**
 * Create the Markdown from the heading and body pair.
 * @param options The options.
 */
exports.default = ({ body = '', head, level = 1 }) => list_1.line(`${'#'.repeat(level)} ${head}`.trim(), '', body.trim());
//# sourceMappingURL=article.js.map